import * as C from '../constants';

export default {
  [C.GIFT_VOUCHER_TEMPLATES_DOMAINS_PENDING](state) {
    state.domains = {
      loading: true,
      items: [],
      error: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_DOMAINS_SUCCESS](state, payload) {
    state.domains = {
      loading: false,
      items: payload,
      error: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_DOMAINS_FAILURE](state) {
    state.domains = {
      loading: false,
      items: [],
      error: true,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_DOMAINS_SET](state, payload) {
    state.domain = payload;
  },

  [C.GIFT_VOUCHER_TEMPLATES_PENDING](state) {
    state.templates = {
      loading: true,
      items: [],
      error: false,
      noContent: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_SUCCESS](state, payload) {
    state.templates = {
      loading: false,
      items: payload,
      error: false,
      noContent: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_FAILURE](state) {
    state.templates = {
      loading: false,
      items: [],
      error: true,
      noContent: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_NO_CONTENT](state) {
    state.templates = {
      loading: false,
      items: [],
      error: false,
      noContent: true,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_SAVE_PENDING](state) {
    state.save = {
      loading: true,
      error: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_SAVE_SUCCESS](state) {
    state.save = {
      loading: false,
      error: false,
    };
  },

  [C.GIFT_VOUCHER_TEMPLATES_SAVE_FAILURE](state) {
    state.save = {
      loading: false,
      error: true,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucherTemplates/mutations.js